import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { ECO_WIDGET_TYPES } from './eco';
import { EI_WIDGET_TYPES } from './ei';
import AutoRCA from '../widgets/network-widget/AutoRCA';
import SPIWidget from '../widgets/spi-widget/SPIWidget';
import SPIOpportunitiesWidget from '../widgets/spi-widget/OpportunitiesWidget';
import QOEOpportunitiesWidget from '../widgets/qoe-widget/OpportunitiesWidget';
import QOEWidget from '../widgets/qoe-widget/QOEWidget';
import StreamsWidget from '../widgets/spi-widget/StreamsWidget';
import MetricGroup from '../widgets/metric-group-widget';
import Flow from '../widgets/flow-widget';
import NetworkResponseWidget from '../widgets/network-widget/NetworkResponseWidget';
import NetworkDurationWidget from '../widgets/network-widget/NetworkDurationWidget';
import NetworkPercentileWidget from '../widgets/network-widget/NetworkPercentileWidget';
import Viewers from '../widgets/viewers-widget/Viewers';
import ImpactedTimeWidget from '../widgets/qoe-widget/ImpactedTimeWidget';
import EventMetricGroup from '../widgets/event-metric-widget';
import ANRWidget from '../widgets/metric-group-widget/ANRWidget';
import CrashesWidget from '../widgets/metric-group-widget/CrashesWidget';

const eiWidgetComponentMap = {
  [EI_WIDGET_TYPES.streamingPerformanceIndex]: SPIWidget,
  [EI_WIDGET_TYPES.improvementOpportunities]: SPIOpportunitiesWidget,
  [EI_WIDGET_TYPES.streams]: StreamsWidget,
  [EI_WIDGET_TYPES.metricGroup]: MetricGroup,
  [EI_WIDGET_TYPES.viewers]: Viewers,
};

const ecoWidgetComponentMap = {
  [ECO_WIDGET_TYPES.networkResponse]: NetworkResponseWidget,
  [ECO_WIDGET_TYPES.networkDuration]: NetworkDurationWidget,
  [ECO_WIDGET_TYPES.improvementOpportunities]: QOEOpportunitiesWidget,
  [ECO_WIDGET_TYPES.autoRca]: AutoRCA,
  [ECO_WIDGET_TYPES.networkPercentile]: NetworkPercentileWidget,
  [ECO_WIDGET_TYPES.metricGroup]: MetricGroup,
  [ECO_WIDGET_TYPES.flow]: Flow,
  [ECO_WIDGET_TYPES.qoe]: QOEWidget,
  [ECO_WIDGET_TYPES.impactedTime]: ImpactedTimeWidget,
  [ECO_WIDGET_TYPES.eventMetricGroup]: EventMetricGroup,
  [ECO_WIDGET_TYPES.anr]: ANRWidget,
  [ECO_WIDGET_TYPES.crashes]: CrashesWidget,
};

export const widgetComponentMap =
  {
    EI: eiWidgetComponentMap,
    APP: ecoWidgetComponentMap,
  }[CURRENT_PRODUCT_MODE] || {};
